export default __webpack_public_path__ + "static/media/complementary--when-snowy--g1.eb82e32c.png";